import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { NavigationItem, NavigationLink } from '../../interfaces/navigation-item.interface';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';
import { MatRipple } from '@angular/material/core';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-navigation-item',
	templateUrl: './navigation-item.component.html',
	styleUrls: ['./navigation-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatRipple, NgClass, RouterLink, MatMenuTrigger, MatMenu, MatMenuItem, MatIcon, NgTemplateOutlet, AsyncPipe],
})
export class NavigationItemComponent {
	private navigationService = inject(NavigationService);
	private router = inject(Router);

	@Input() item: NavigationItem;

	isActive$ = this.router.events.pipe(
		filter((event) => event instanceof NavigationEnd),
		startWith(null),
		map(() => (item: NavigationItem) => this.hasActiveChilds(item))
	);

	isLink = this.navigationService.isLink;
	isDropdown = this.navigationService.isDropdown;
	isSubheading = this.navigationService.isSubheading;

	hasActiveChilds(parent: NavigationItem): boolean {
		if (this.isLink(parent)) {
			return this.router.isActive(parent.route as string, true);
		}

		if (this.isDropdown(parent) || this.isSubheading(parent)) {
			return parent.children.some((child) => {
				if (this.isDropdown(child)) {
					return this.hasActiveChilds(child);
				}

				if (this.isLink(child) && !this.isFunction(child.route)) {
					return this.router.isActive(child.route as string, true);
				}

				return false;
			});
		}

		return false;
	}

	isFunction(prop: NavigationLink['route']) {
		return prop instanceof Function;
	}
}
